import { CheckableAvatarSelectItem, Select } from '@dixa/lib-shared-habla';
import { User } from 'lib-shared-types-api';
import { memo, useCallback } from 'react';

import { useAgents } from 'hooks/useAgents';
import { getUserDisplayName } from 'utils/user';

interface AgentsSelectProps {
  selectedItems: User[];
  selectAgent: (agent: User) => void;
  deselectAgent: (agent: User) => void;
  teamId?: string;
  queueId?: string;
}

/** @deprecated Use `HookFormAgentSelect` instead. */
export const AgentsSelect = memo<AgentsSelectProps>(
  ({ teamId, queueId, selectedItems, selectAgent, deselectAgent }) => {
    const {
      items: agents,
      changeParams,
      asyncStatus,
      params,
      hasNextPage,
      hasPreviousPage,
      nextPage,
      previousPage,
    } = useAgents({
      filter_out_by_team: teamId,
      filter_out_by_queue: queueId,
    });

    const handleChange = useCallback(
      (agent: User, isSelected: boolean) => {
        if (isSelected) {
          selectAgent(agent);
        } else {
          deselectAgent(agent);
        }
      },
      [deselectAgent, selectAgent],
    );

    const items = agents.map((agent) => ({
      id: agent.id,
      name: getUserDisplayName(agent),
    }));

    const selectedItemIds = selectedItems.map((agent) => agent.id);

    return (
      <Select
        placeholder="Select one or more agents"
        items={items}
        selectedItems={selectedItemIds}
        onSearch={(searchValue) => changeParams({ search: searchValue })}
        onChange={handleChange}
        loading={asyncStatus === 'loading'}
        emptyMessage={params.search ? 'No agents found' : 'No agents available'}
        pagination={{
          nextEnable: hasNextPage,
          previousEnable: hasPreviousPage,
          onNext: nextPage as any,
          onPrevious: previousPage as any,
        }}
        itemComponent={CheckableAvatarSelectItem}
        searchable
        multiple
      />
    );
  },
);

AgentsSelect.displayName = 'AgentsSelect';
